import React from 'react';

import StoryObject from '@atlaskit/object/story';

export default function ObjectDefault(): React.JSX.Element {
	return <StoryObject />;
}
